<script>
import BookingListGroupSkeleton from '@/components/skeleton/booking-list-group-skeleton.vue'
import baseMixin from '@/mixins/baseMixin'
import BookingList from '../booking-list.vue'

export default {
  name: 'BookingSummaryList',
  components: {
    BookingList,
    BookingListGroupSkeleton,
  },
  mixins: [baseMixin],
  props: {
    loadingCount: {
      type: Number,
      default: 0,
    },
    bookings: {
      type: Array,
      default: () => [],
    },
    expandAll: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      accordion: [],
    }
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0
    },
  },
  watch: {
    expandAll() {
      this.determinePanelExpandState()
    },
    loadingCount() {
      if (!this.expandAll) {
        // Open first accordion
        this.accordion.push(0)
      } else {
        this.determinePanelExpandState()
      }
    },
  },
  methods: {
    determinePanelExpandState() {
      this.accordion = this.expandAll
        ? [...Array(this.bookings.length).keys()].map((k, i) => i)
        : []
    },
    cancelBooking(value) {
      this.$emit('cancelBooking', value)
    },
  },
}
</script>

<template>
  <v-expansion-panels
    v-if="!isLoading"
    v-model="accordion"
    accordion
    flat
    multiple
    hover
  >
    <v-expansion-panel
      v-for="client of bookings"
      :key="client.clientId"
      class="transparent"
    >
      <v-expansion-panel-header>{{
        client.clientName
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div
          v-for="location in client.locations"
          :key="`booking-summary-card__location-${location.locationId}`"
        >
          <v-toolbar flat dense class="transparent mb-4">
            <v-toolbar-title class="subtitle-2 font-weight-medium">
              {{ location.locationName }}
            </v-toolbar-title>
          </v-toolbar>

          <BookingList
            :bookings="location.bookings"
            @cancelBooking="cancelBooking"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <BookingListGroupSkeleton v-else :rows="loadingCount" />
</template>
